/*
 * mh-konf-ga4.js — GA4-Events (dataLayer) fuer alle fuenf myHarry-Konfiguratoren
 * 28.10.2026, Konfiguratoren-Push (Asana „GA4-Events für Konfiguratoren“)
 *
 * Reine Beobachtung, die Konfiguratoren selbst bleiben unveraendert. Eingebunden am Ende von
 * snippets/mh-konf-aktion.liquid (defer, laedt damit VOR mh-konf-suite.js, NACH mh-konf-track.js).
 *
 * dataLayer-Events (alle mit configurator_type = terrassenplatten | wpc_dielen | sichtschutz |
 * doppelstab | pergola und configurator_source = seite | popup):
 *   configurator_start   erste Interaktion im Konfigurator (pointerup / change / keydown),
 *                        je Konfigurator einmal pro Seitenaufruf
 *   configurator_result  Stueckliste mit Preis wird angezeigt (value, currency)
 *                        - WPC/Terrassen/Sichtschutz/Doppelstab: Karte „Dein Set steht“ (.mhks-set,
 *                          zeigt mh-konf-suite.js erst im letzten Schritt) ist sichtbar
 *                        - Pergola: Event 'mh:konf:final' aus assets/mh-pergola.js mit final = true
 *                        entprellt (1,5 s stabil), erneut nur bei geaendertem Preis nach Aus-/Einblenden
 *                        oder Preisaenderung (max. 5 je Konfigurator und Seitenaufruf)
 *   configurator_add_to_cart  (bis 28.10. (3): add_to_cart) nach ERFOLGREICHEM /cart/add (fetch-Huelle);
 *                        items aus der Shopify-Antwort (Titel, Preis) + Mengen aus der Anfrage
 * Zusaetzlich: Shopify.analytics.publish('configurator_start' | 'configurator_result' |
 * 'configurator_add_to_cart', ...) fuer ein Custom Pixel (Kundenereignisse).
 *
 * Warenkorb-Attribut configurator_type: nach erfolgreichem Hinzufuegen wird es per /cart/update.js
 * ergaenzt (kommagetrennt, z. B. "wpc_dielen,pergola"). Nur dieser eine Schluessel wird geschickt,
 * Shopify fuehrt Attribute zusammen – „Konfigurator“ (mh-konf-suite.js) und andere bleiben erhalten.
 *
 * 28.10.2026 (2): Pergola wie die anderen als Konfigurator-Bestellung kennzeichnen (Shopify Flow
 * „Bestell-Tag Konfigurator“). Nur fuer Pergola-Positionen (Varianten-IDs aus dem letzten
 * 'mh:konf:final' bzw. Eigenschaft _set "SkyShade…"):
 *   - Line-Item-Property _konfigurator = "Pergola" im /cart/add-Body (vorhandene Properties bleiben)
 *   - Cart-Attribut "Konfigurator": leer -> "Pergola"; sonst ", Pergola" anhaengen (falls noch nicht drin)
 * Hinweis: mh-konf-suite.js selbst kombiniert nicht, sie setzt "Konfigurator" bei jedem Hinzufuegen
 * auf den zuletzt genutzten Namen (z. B. "WPC-Dielen").
 *
 * 28.10.2026 (3): Kein GTM im Shop, nur gtag.js. Deshalb geht jedes Event GENAU EINMAL direkt per
 *   gtag('event', <name>, {..., send_to: 'G-1JEKYJVB9R'}) an GA4 (Consent Mode gilt wie fuer alle gtag-Aufrufe):
 *     configurator_start, configurator_result, configurator_add_to_cart (items im GA4-Format;
 *     bewusst NICHT add_to_cart, damit es nicht mit dem add_to_cart der Shopify-/Google-App doppelt zaehlt).
 *   Der dataLayer-Push bleibt fuer ein spaeteres GTM, aber mit eigenem Namen mh_<event> (mh_configurator_start,
 *   mh_configurator_result, mh_configurator_add_to_cart) und Kennung mh_ga4: true. gtag.js verarbeitet nur
 *   eigene Befehle (arguments-Objekte aus gtag()), keine {event:...}-Objekte als GA4-Treffer; durch die
 *   eigenen Namen kann es selbst bei einem spaeteren GTM-Container nie zu gleichnamigen Doppel-Events kommen.
 *   Ohne gtag (z. B. vor dem Laden) wird nichts nachgereicht – kein Puffern, kein Umgehen der Einwilligung.
 *
 * Debug: ?mhga4debug=1 (bleibt fuer die Sitzung aktiv, ?mhga4debug=0 schaltet ab) -> Konsole.
 * Test:  window.MH_GA4_TEST = function (obj) {...} bekommt jedes Objekt statt dataLayer.
 */
(function () {
  'use strict';
  if (window.MHGA4) return;

  var DEBUG = false;
  try {
    var qm = /[?&]mhga4debug=([01])/.exec(window.location.search);
    if (qm) sessionStorage.setItem('mhga4debug', qm[1]);
    DEBUG = sessionStorage.getItem('mhga4debug') === '1';
  } catch (e) { DEBUG = /[?&]mhga4debug=1/.test(window.location.search); }
  function log() { if (DEBUG && window.console) { try { console.log.apply(console, ['[mh-ga4]'].concat([].slice.call(arguments))); } catch (e) {} } }

  /* key = Kuerzel in mh-konf-suite.js / mh-konf-track.js */
  var K = [
    { key: 'wpc',        type: 'wpc_dielen',       name: 'WPC-Dielen',           sel: '#mhWpcRoot' },
    { key: 'terrassen',  type: 'terrassenplatten', name: 'Terrassenplatten',     sel: '#mhKonfRoot' },
    { key: 'zaun',       type: 'sichtschutz',      name: 'Sichtschutzzaun',      sel: '.mhzk-app' },
    { key: 'doppelstab', type: 'doppelstab',       name: 'Doppelstabmattenzaun', sel: '.mhds-app' },
    { key: 'pergola',    type: 'pergola',          name: 'Pergola',              sel: '#mhpg-select, #mhpg-cta' }
  ];
  var BY_NAME = {};
  K.forEach(function (k) { BY_NAME[k.name] = k; });

  function currency() {
    try { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'; } catch (e) { return 'EUR'; }
  }
  function shown(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function quelle(el) { return el && el.closest && el.closest('.mhtk-modal,[role="dialog"]') ? 'popup' : 'seite'; }
  function r2(n) { return Math.round(n * 100) / 100; }
  function parseEur(s) {   /* "1.234,56 €" -> 1234.56 */
    s = String(s || '').replace(/[^\d,.-]/g, '');
    if (!s) return 0;
    if (s.indexOf(',') >= 0) s = s.replace(/\./g, '').replace(',', '.');
    var n = parseFloat(s);
    return isFinite(n) ? r2(n) : 0;
  }

  /* ---------- Ausgabe ---------- */
  var GA4_ID = 'G-1JEKYJVB9R';
  var dl = window.dataLayer = window.dataLayer || [];
  function push(obj) {
    log('dataLayer', obj);
    if (typeof window.MH_GA4_TEST === 'function') { try { window.MH_GA4_TEST(obj); } catch (e) {} return; }
    try { dl.push(obj); } catch (e) {}
  }
  /* genau ein GA4-Treffer je Event: gtag + dataLayer-Kopie unter mh_<name> */
  function send(name, params) {
    var dlo = { event: 'mh_' + name, mh_ga4: true }, k;
    for (k in params) if (Object.prototype.hasOwnProperty.call(params, k)) dlo[k] = params[k];
    if (params.items) { push({ ecommerce: null }); dlo.ecommerce = { currency: params.currency, value: params.value, items: params.items }; delete dlo.items; }
    push(dlo);
    var gp = { send_to: GA4_ID };
    for (k in params) if (Object.prototype.hasOwnProperty.call(params, k)) gp[k] = params[k];
    if (typeof window.MH_GA4_TEST === 'function') { try { window.MH_GA4_TEST({ gtag: name, params: gp }); } catch (e) {} return; }
    if (typeof window.gtag === 'function') {
      try { window.gtag('event', name, gp); log('gtag', name, gp); } catch (e) { log('gtag Fehler', e); }
    } else log('gtag fehlt – nicht an GA4 gesendet:', name);
  }
  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }

  /* ---------- configurator_start ---------- */
  var started = {}, last = null, lastT = 0;
  function fireStart(k, src, auto) {
    if (started[k.type]) return;
    started[k.type] = 1;
    var p = { configurator_type: k.type, configurator_source: src || 'seite' };
    if (auto) p.configurator_start_auto = true;   /* Ergebnis ohne vorherige Interaktion (z. B. geteilter Link) */
    send('configurator_start', p);
    publish('configurator_start', { configurator_type: k.type, configurator_source: src || 'seite' });
  }
  function hit(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    for (var i = 0; i < K.length; i++) {
      var r = t.closest(K[i].sel);
      if (!r) continue;
      last = K[i]; lastT = Date.now();
      fireStart(K[i], quelle(r));
      return;
    }
  }
  document.addEventListener('pointerup', hit, true);
  document.addEventListener('change', hit, true);
  document.addEventListener('keydown', hit, true);

  /* ---------- configurator_result ---------- */
  var MAX_RESULTS = 5;
  var res = {};   /* je type: { cand, candT, sent, n, vis } */
  function rs(type) { return res[type] || (res[type] = { cand: null, candT: 0, sent: null, n: 0, vis: false }); }
  function fireResult(k, value, src) {
    var st = rs(k.type);
    if (st.n >= MAX_RESULTS) return;
    if (!started[k.type]) fireStart(k, src, true);
    st.n++; st.sent = value;
    send('configurator_result', { configurator_type: k.type, configurator_source: src || 'seite', value: value, currency: currency() });
    publish('configurator_result', { configurator_type: k.type, value: value, currency: currency() });
  }
  /* Kandidat merken; gesendet wird erst, wenn derselbe Wert 1,5 s stabil sichtbar ist */
  function candidate(k, value, src, visible) {
    var st = rs(k.type), now = Date.now();
    if (!visible || !(value > 0)) {
      st.vis = false; st.cand = null;
      return;
    }
    if (st.cand !== value) { st.cand = value; st.candT = now; st.src = src; return; }
    if (now - st.candT < 1500) return;
    if (st.sent === value) { st.vis = true; return; }   /* gleicher Wert wie zuletzt gesendet: nicht doppelt */
    st.vis = true;
    fireResult(k, value, st.src);
  }
  function scanResults() {
    for (var i = 0; i < 4; i++) {   /* die vier mit Set-Karte aus mh-konf-suite.js */
      var k = K[i], list = document.querySelectorAll(k.sel), found = false;
      for (var j = 0; j < list.length; j++) {
        var card = list[j].querySelector('.mhks-set');
        if (!card || card.hidden || !shown(card)) continue;
        var v = parseEur((card.querySelector('.mhks-set__pr b') || {}).textContent);
        if (!(v > 0)) continue;
        found = true;
        candidate(k, v, quelle(list[j]), true);
        break;
      }
      if (!found) candidate(k, 0, null, false);
    }
    if (pg.final && pg.value > 0) candidate(K[4], pg.value, 'seite', true);
    else candidate(K[4], 0, null, false);
  }
  /* Pergola: Event aus assets/mh-pergola.js (nach jedem render) */
  var pg = { final: false, value: 0, ids: {} };
  document.addEventListener('mh:konf:final', function (e) {
    var d = e && e.detail;
    if (!d || d.key !== 'pergola') return;
    var data = d.data || {};
    pg.final = !!d.final && !!started.pergola;   /* Rendern beim Laden zaehlt nicht */
    pg.value = r2((+data.preis || 0) / 100);
    var ids = {};
    (data.positionen || []).forEach(function (l) { if (l && l.id) ids[String(l.id)] = 1; });
    if (Object.keys(ids).length) pg.ids = ids;
  });
  function isPgItem(it) {
    if (!it) return false;
    var pr = it.properties || {};
    if (pr._set && /^SkyShade/i.test(String(pr._set))) return true;
    return !!(document.getElementById('mhpg-data') && pg.ids[String(it.id)]);
  }

  /* ---------- add_to_cart (fetch-Huelle) ---------- */
  function bodyItems(body) {
    if (!body) return [];
    if (body.items && body.items.length) return body.items;
    if (body.id) return [body];
    return [];
  }
  function typeFromBody(items) {
    for (var i = 0; i < items.length; i++) {
      var pr = items[i] && items[i].properties;
      if (!pr) continue;
      if (pr._konfigurator && BY_NAME[pr._konfigurator]) return BY_NAME[pr._konfigurator];
      if (pr._konfigurator) continue;
    }
    for (var j = 0; j < items.length; j++) if (isPgItem(items[j])) return K[4];
    return null;
  }
  function gaItems(k, items, resp) {
    var qty = {};
    items.forEach(function (it) { var id = String(it.id); qty[id] = (qty[id] || 0) + (+it.quantity || 1); });
    var lines = resp && resp.items ? resp.items : (resp && resp.variant_id ? [resp] : []);
    var out = [], seen = {};
    lines.forEach(function (l) {
      var id = String(l.variant_id || l.id);
      if (seen[id] || !qty[id]) return; seen[id] = 1;   /* nur angefragte Positionen */
      var q = qty[id] || +l.quantity || 1;
      var price = r2(((l.final_price != null ? l.final_price : l.price) || 0) / 100);
      var o = {
        item_id: String(l.sku || id),
        item_name: l.product_title || l.title || '',
        item_variant: l.variant_title || '',
        item_brand: l.vendor || '',
        item_category: l.product_type || '',
        item_list_id: 'konfigurator_' + k.type,
        item_list_name: 'Konfigurator ' + k.name,
        price: price,
        quantity: q,
        variant_id: id,
        product_id: l.product_id ? String(l.product_id) : ''
      };
      out.push(o);
    });
    if (!out.length) {   /* Antwort nicht lesbar: wenigstens IDs + Mengen */
      Object.keys(qty).forEach(function (id) { out.push({ item_id: id, variant_id: id, quantity: qty[id], item_list_id: 'konfigurator_' + k.type }); });
    }
    return out;
  }
  function fireAdd(k, items, resp) {
    var gi = gaItems(k, items, resp);
    var value = r2(gi.reduce(function (t, x) { return t + (x.price || 0) * (x.quantity || 0); }, 0));
    if (!started[k.type]) fireStart(k, 'seite', true);
    send('configurator_add_to_cart', { configurator_type: k.type, value: value, currency: currency(), items: gi });
    publish('configurator_add_to_cart', { configurator_type: k.type, value: value, currency: currency(), items: gi });
  }

  var nf = window.fetch;
  /* Cart-Attribut configurator_type ergaenzen (nur dieser Schluessel, bestehende bleiben) */
  var attrBusy = false, attrQ = [];
  function setAttr(type) {
    if (!nf) return;
    if (attrBusy) { if (attrQ.indexOf(type) < 0) attrQ.push(type); return; }
    attrBusy = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    nf.call(window, root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var cur = cart && cart.attributes && cart.attributes.configurator_type ? String(cart.attributes.configurator_type) : '';
        var list = cur ? cur.split(/\s*,\s*/).filter(Boolean) : [];
        [type].concat(attrQ).forEach(function (t) { if (list.indexOf(t) < 0) list.push(t); });
        attrQ = [];
        var val = list.join(','), upd = {};
        if (val !== cur) upd.configurator_type = val;
        /* Pergola: Attribut "Konfigurator" wie bei den anderen (Flow), nur ergaenzen */
        if (list.indexOf('pergola') >= 0) {
          var kc = cart && cart.attributes && cart.attributes.Konfigurator ? String(cart.attributes.Konfigurator).trim() : '';
          var kl = kc ? kc.split(/\s*,\s*/) : [];
          if (kl.indexOf('Pergola') < 0) upd.Konfigurator = kc ? kc + ', Pergola' : 'Pergola';
        }
        if (!Object.keys(upd).length) { log('Cart-Attribute unveraendert', val); return; }
        log('Cart-Attribute ergaenzt', upd);
        return nf.call(window, root + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: upd })
        });
      })
      .catch(function (e) { log('Cart-Attribut Fehler', e); })
      .then(function () { attrBusy = false; if (attrQ.length) setAttr(attrQ.shift()); });
  }

  if (nf) {
    window.fetch = function (input, init) {
      var k = null, items = [];
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
          var body = null;
          try { body = JSON.parse(init.body); } catch (x) { body = null; }
          items = bodyItems(body);
          if (items.length) k = typeFromBody(items);
          /* Pergola: Kennung _konfigurator nur an Pergola-Positionen, bestehende Properties bleiben */
          if (k === K[4]) {
            var tagged = 0;
            items.forEach(function (it) {
              if (!isPgItem(it)) return;
              it.properties = it.properties || {};
              if (!it.properties._konfigurator) { it.properties._konfigurator = 'Pergola'; tagged++; }
            });
            if (tagged) { init = Object.assign({}, init, { body: JSON.stringify(body) }); log('Pergola: _konfigurator an', tagged, 'Position(en)'); }
          }
        }
      } catch (e) { k = null; }
      var p = nf.call(this, input, init);
      if (k) {
        var kk = k, its = items;
        if (kk === K[4]) its = items.filter(isPgItem);   /* nur Pergola-Positionen zaehlen */
        p.then(function (r) {
          if (!r || !r.ok) { log('add fehlgeschlagen', kk.type); return; }
          var c = null;
          try { c = r.clone(); } catch (e) { c = null; }
          (c ? c.json().catch(function () { return null; }) : Promise.resolve(null)).then(function (j) {
            fireAdd(kk, its, j);
            setTimeout(function () { setAttr(kk.type); }, 1500);   /* nach Suite-Update (Kennung/Ersetzen) */
          });
        }).catch(function () {});
      }
      return p;
    };
  }

  /* ---------- Start ---------- */
  setInterval(scanResults, 1000);
  document.addEventListener('mhkonf:dom', function () { setTimeout(scanResults, 50); });
  window.MHGA4 = { push: push, send: send, scan: scanResults, state: function () { return { started: started, results: res, pergola: pg }; } };
  log('bereit', { debug: DEBUG });
})();
